var map = {
	"./BNB.png": "7d35",
	"./BTC.png": "68eea",
	"./CAKE.png": "e541",
	"./DOT.png": "84b8",
	"./ETH.png": "b372",
	"./HT.png": "4e72",
	"./MATIC.png": "2db7",
	"./OKT.png": "51ab",
	"./TPT.png": "0ca0",
	"./TRX.png": "65eb5",
	"./UNI.png": "aaae",
	"./drop.png": "7751",
	"./drop_shadow.png": "9d52",
	"./rise.png": "8b39",
	"./rise_shadow.png": "1037",
	"./title.png": "ee0b",
	"./title_zh.png": "0806"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de14";